import React, { FC } from 'react'
import { Grid, Typography, WithStyles, createStyles, Theme, withStyles } from '@material-ui/core'

import Jersey from 'components/Jersey'
import { IMatch } from 'protos'

interface Props extends WithStyles {
  match: IMatch
}

const styles = (theme: Theme) => createStyles({
  jerseyHome: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(),
  },
  jerseyAway: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(2),
  },
  teamName: {
    flex: 1,
    marginTop: theme.spacing(),
  },
})

const MatchCarouselItem: FC<Props> = ({ match, classes }) => {
  return (
    <Grid container>
      <Grid item xs container wrap="nowrap">
        <Jersey
          size="medium"
          className={classes.jerseyHome}
          jersey={match.homeTeam && match.homeTeam.jersey}
        />
        <Typography variant="body1" className={classes.teamName}>
          {match.homeTeam && match.homeTeam.name}
        </Typography>
      </Grid>
      <Grid item xs container wrap="nowrap">
        <Typography variant="body1" align="right" className={classes.teamName}>
          {match.awayTeam && match.awayTeam.name}
        </Typography>
        <Jersey
          size="medium"
          className={classes.jerseyAway}
          jersey={match.awayTeam && match.awayTeam.jersey}
        />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(MatchCarouselItem)
